<div class="discussions">
    <fw-discussion-topic-list [DataSourceId]="DataSourceId" (TopicClicked)="LoadTopic($event)" [DiscussionListWidgetConfigurationViewDTO]="DiscussionListWidgetConfigurationViewDTO">
    </fw-discussion-topic-list>
    <div *ngIf="topicListFacade._discussionsExist" class="selected-topic">
        <fw-discussion-topic-comment [DataSourceId]="DataSourceId" [AddDiscussionCommentButtonResourceId] ="DiscussionListWidgetConfigurationViewDTO.AddDiscussionCommentButtonResourceId"></fw-discussion-topic-comment>
        <fw-discussion-comments-list></fw-discussion-comments-list>
    </div>
</div>